<template>
    <b-modal 
        :id="id" 
        :ref="id" 
        modal-class="modal-template-default modal-success" 
        centered
        hide-footer
    >
        <template v-slot:modal-header="">
            <h1 class="modal-title">{{ title }}</h1>

            <b-button v-on:click.prevent="close" class="close-modal-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="close-icon bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                </svg>
            </b-button>
        </template>

        <section>
            <article>
                <p class="text-center">{{ text }}</p>
            </article>
        </section>

        <div class="button-wrapper">
            <app-button-primary text="Ok" v-on:click.native="close"/>
        </div>
    </b-modal>
</template>

<script>
    import AppButtonPrimary from '@/components/ui/buttons/AppButtonPrimary';

    export default {
        name: 'AppModalSuccess',

        components: { AppButtonPrimary },

        props: {
            id: String,
            title: String,
            text: String,
        },

        methods: {
            close() {
                this.$bvModal.hide(this.id);
            }
        }
    }
</script>

<style lang="scss">
   .modal-success {
        @import "@/assets/scss/components/ui/modals/appModalTemplate";


        .modal-dialog {
            .modal-content {
                .modal-header {
                    background-color: $lsColor;
                    color: #fff;
                }

                p {
                    margin-bottom: 0;
                }

                .button-wrapper {
                    display: flex;
                    width: 100%;
                    justify-content: center;

                    button {
                        margin-bottom: 0;
                        width: 100%;
                        max-width: 280px;
                    }
                }
            }
        }
   
    }
</style>
